@if (detailService.voucherType() | async) {
    <p-card>
        <p-tabs class="override" [value]="VoucherTab.general">
            <p-tablist>
                @for (tab of tabs; track $index) {
                    <p-tab [value]="tab.Id">
                        <span>{{ tab.Label }}</span>
                        @if (tab.isInvalid$ | async) {
                            <i class="pi pi-exclamation-triangle text-danger ml-2"></i>
                        }
                    </p-tab>
                }
            </p-tablist>

            <p-tabpanels>
                @for (tab of tabs; track $index) {
                    <p-tabpanel [value]="tab.Id">
                        @switch (tab.Id) {
                            @case (detailService.viewTabs.general) {
                                <app-voucher-detail-general [voucher]="voucher$ | async"></app-voucher-detail-general>
                            }
                            @case (detailService.viewTabs.situationDP) {
                                <app-voucher-detail-situation-dp></app-voucher-detail-situation-dp>
                            }
                            @case (detailService.viewTabs.situationORP) {
                                <app-voucher-detail-situation-orp></app-voucher-detail-situation-orp>
                            }
                            @case (detailService.viewTabs.situationFT) {
                                <app-voucher-detail-situation-ft></app-voucher-detail-situation-ft>
                            }
                            @case (detailService.viewTabs.prescriptions) {
                                <app-voucher-detail-prescriptions></app-voucher-detail-prescriptions>
                            }
                            @default {
                                neexistujici tab
                            }
                        }
                    </p-tabpanel>
                }
            </p-tabpanels>
        </p-tabs>
    </p-card>

    <app-action-buttons
        [primaryButtonDisability]="formInvalid$ | async"
        [primaryButtonVisibility]="folderStore.canEdit()"
        (primaryClickEvent)="submit()"
        (secondaryClickEvent)="cancel()"
    ></app-action-buttons>
} @else {
    <app-loading></app-loading>
}
